var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeedar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1161.1 304.2",
    style: {
      enableBackground: "new 0 0 1161.1 304.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{opacity:0.1;}\n\t.st2{opacity:0.64;}\n\t.st3{opacity:0.21;}\n\t.st4{opacity:0.4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.6,248.3H31.2c-10.9,0-20.6-5.6-26-15c-5.4-9.4-5.4-20.7,0-30.1L112.9,17.1c5.4-9.4,15.2-15,26-15 s20.6,5.6,26,15l107.7,186.1c5.4,9.4,5.5,20.6,0,30.1C267.2,242.6,257.5,248.3,246.6,248.3z M138.9,5.8c-9.5,0-18,4.9-22.8,13.1 L8.3,205c-4.8,8.3-4.8,18.1,0,26.4c4.8,8.3,13.3,13.2,22.8,13.2h215.5c9.5,0,18.1-4.9,22.8-13.2c4.8-8.3,4.8-18.1,0-26.4 L161.7,18.9C156.9,10.7,148.4,5.8,138.9,5.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.6,302.1c-10.7,0-20.3-5.5-25.7-14.8L7.6,103.6c-5.4-9.3-5.4-20.4,0-29.7c5.4-9.3,15-14.8,25.7-14.8 h212.7c10.7,0,20.3,5.6,25.7,14.8c5.4,9.3,5.3,20.4,0,29.7L165.3,287.3C159.9,296.6,150.3,302.1,139.6,302.1z M33.3,62.8 c-9.4,0-17.8,4.9-22.5,13c-4.7,8.2-4.7,17.9,0,26l106.3,183.7c4.7,8.1,13.1,13,22.5,13s17.8-4.9,22.5-13l106.3-183.7 c4.7-8.1,4.7-17.9,0-26c-4.7-8.2-13.1-13-22.5-13H33.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M195.2,262.1H80.3c-27.3,0-51.5-14-64.9-37.4c-13-22.8-12.8-50,0.6-72.6L75.8,51c13-22,36.2-35.1,62-35.1 s49,13.1,62,35.1l59.8,101.1c13.4,22.6,13.6,49.8,0.6,72.6C246.7,248.1,222.4,262.1,195.2,262.1z M137.7,19.7 c-24.5,0-46.5,12.4-58.8,33.3L19.2,154c-12.7,21.5-12.9,47.3-0.5,68.9c12.7,22.2,35.7,35.5,61.6,35.5h114.9 c25.9,0,49-13.3,61.7-35.5c12.4-21.7,12.2-47.4-0.5-68.9L196.5,52.9C184.2,32.1,162.2,19.7,137.7,19.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M137.4,290.8c-25.1,0-47.7-12.8-60.3-34.1L19,158.3c-13-22-13.2-48.4-0.6-70.7c13-22.8,36.6-36.4,63.1-36.4 h111.8c26.5,0,50.1,13.6,63.1,36.4c12.7,22.2,12.5,48.6-0.6,70.6l-58.1,98.3C185.1,278,162.5,290.8,137.4,290.8z M80.2,254.8 c12,20.3,33.4,32.4,57.2,32.4c23.8,0,45.2-12.1,57.2-32.4l58.1-98.3c12.4-20.9,12.6-46,0.5-67c-12.3-21.6-34.8-34.5-60-34.5H81.5 c-25.2,0-47.6,12.9-60,34.5c-12,21.1-11.8,46.1,0.5,67L80.2,254.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183,278.5H94c-15.6,0-30-8.4-37.7-21.9l-45.1-79.4c-7.5-13.2-7.5-29.6,0-42.8L56.3,55C64,41.4,78.5,33,94,33 H183c15.6,0,30,8.4,37.7,21.9l45.1,79.4c7.5,13.2,7.5,29.6,0,42.8l-45.1,79.4C213,270.1,198.5,278.5,183,278.5z M94,36.7 c-14.2,0-27.4,7.7-34.5,20.1l-45.1,79.4c-6.8,12.1-6.8,27.1,0,39.1l45.1,79.4c7,12.4,20.2,20.1,34.5,20.1H183 c14.2,0,27.4-7.7,34.5-20.1l45.1-79.4c6.9-12.1,6.9-27.1,0-39.1l-45.1-79.4c-7-12.4-20.2-20.1-34.5-20.1H94z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1161.1,129.7 1091,129.7 1091,222.4 1066,222.4 1066,104.8 1091,104.8 1091,118.7 1114.4,104.8  1146.3,104.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1044.9,129.7l-14.8-24.9h-90.3v24.9h69.9l-65.5,37.8l-24.9,14.4v40.6h128.6v-0.2h4v-81L1044.9,129.7z  M1026.9,197.7h-85.1l2.3-1.3l82.8-47.8V197.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M880.3,72.1v33.3h-61.3l-26,15.4l-11.8,7l-0.1,0.1v94.9h124.2V72.1H880.3z M805.9,197.8v-67.6h49.5l24.8-14.7 v82.3H805.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "395.6,197 395.6,197.3 395.5,197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "395.6,197 395.6,197.3 395.5,197  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "395.6,197.3 395.6,221.9 339.9,221.9 325.1,197 325.1,105.7 350,105.7 350,197 395.5,197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "489.4,105.7 489.3,197 474.5,221.9 467.6,221.9 467.6,221.9 410.3,221.9 395.6,197.3 395.6,197  395.5,197 395.5,105.7 420.4,105.7 420.4,197 464.5,197 464.5,105.7  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M628.2,150.3v-44.3h-75l-24.8,14.7l-0.1,0.1v-14.8h-24.8v79.9l6.8,11.5l14.8,24.9h91.9v-24.9h-70.1l56.5-32.6 L628.2,150.3z M528.4,179.1v-48.3h74.9v5L528.4,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M692,105.9l-24.8,14.7l-0.1,0.1v-14.8h-24.8v79.9l6.8,11.5l14.8,24.9h91.9v-24.9h-70.1l56.5-32.6l24.9-14.4 v-44.3H692z M667.1,179.1v-48.3h75v5L667.1,179.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "129.7,185.3 129.7,204.9 85.3,204.9 73.5,185.1 73.5,112.5 93.3,112.5 93.3,185.1 129.5,185.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "204.2,112.5 204.1,185.1 192.4,204.9 186.9,204.9 186.9,204.9 141.3,204.9 129.7,185.3 129.7,185.1  129.5,185.1 129.5,112.5 149.3,112.5 149.3,185.1 184.4,185.1 184.4,112.5  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeedar);
export default __webpack_public_path__ + "static/media/weedar.1c0a28311803bae2248f41d3fb5801aa.svg";
export { ForwardRef as ReactComponent };